export interface SystemJSWithMaps {
  import: (moduleId: string, parentUrl?: string) => Promise<unknown>
  addImportMap: (map: Record<string, unknown>, mapBaseUrl?: string) => void
  prepareImport: (processNewImportMapScripts?: boolean) => Promise<void>
}

export function getSystemWithImportMaps(): SystemJSWithMaps {
  return System as unknown as SystemJSWithMaps
}

export function addSystemImportMap(
  map: { imports: Record<string, string> },
  mapBaseUrl?: string
): void {
  getSystemWithImportMaps().addImportMap(map as Record<string, unknown>, mapBaseUrl)
}

export async function prepareSystemImportMaps(): Promise<void> {
  await getSystemWithImportMaps().prepareImport(true)
}
